import { useNavigate } from "react-router-dom";
import logo from '../assets/img/logo.png'
import { Box } from "@mui/material";

const Logo = ({ isMobile }) => {
    const navigate = useNavigate();
    const handleHome = () => {
        navigate('/')
    }

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            p={2}
        >
            <img
                src={logo}
                alt="logo"
                style={{ cursor: 'pointer', width: isMobile ? '120px' : '180px' }}
                onClick={handleHome}
            />
        </Box>

    );
};

export default Logo;